module.exports = __webpack_public_path__ + "img/Analytics.64430e66.png";